import React from 'react';
import PropTypes from 'prop-types';
import { useMatrixFeatureFlag } from '@adsk/bim360-matrix-react-api/es/contexts/launchDarkly';
import { useEnv } from '@adsk/bim360-matrix-react-api/es/contexts/env';
import { REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import FedRAMPLogoSvg from '@adsk/bim360-matrix-react-assets/alloy-fedramp-white.svg';
import accHorizontalWhiteNew2022 from '@adsk/bim360-matrix-react-assets/acc-horizontal-white-new-2022.svg';

const AccOrFedRAMPLogo = ({ isFedRAMP }) => {
  const env = useEnv();
  const { value: isFedrampFFEnabled } = useMatrixFeatureFlag('matrix-fedramp-enabled');
  const isFedrampRegion = isFedrampFFEnabled && env && env.region === REGIONS.FEDRAMP;

  return (
    <SvgIcon width="155px" height="14px">
      {isFedRAMP || isFedrampRegion ? FedRAMPLogoSvg : accHorizontalWhiteNew2022}
    </SvgIcon>
  );
};

AccOrFedRAMPLogo.propTypes = {
  /**
   * Flag for FedRAMP region modifications
   */
  isFedRAMP: PropTypes.bool
};

export default AccOrFedRAMPLogo;
